import { render } from "./AufgabenvorlagenDetailsStatusgruppenTableRowEdit.pug?vue&type=template&id=ff8f5188&lang=pug"
import script from "./AufgabenvorlagenDetailsStatusgruppenTableRowEdit.js?vue&type=script&lang=js"
export * from "./AufgabenvorlagenDetailsStatusgruppenTableRowEdit.js?vue&type=script&lang=js"

import "./AufgabenvorlagenDetailsStatusgruppenTableRowEdit.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__